import request from '@/utils/request'
const baseApi = {
  reportViewTrace: (data) => {
    return request({
      url: '/public/view/trace',
      method: 'post',
      data
    })
  },
  queryProvinceData: params => {
    return request({
      url: '/public/district/province/list',
      method: 'get',
      params
    })
  },
  queryCityData: params => {
    return request({
      url: '/public/district/city/list',
      method: 'get',
      params
    })
  },
  queryCountyData: params => {
    return request({
      url: '/public/district/county/list',
      method: 'get',
      params
    })
  },
  getDistrictList: params => {
    return request({
      url: '/public/district/all',
      method: 'get',
      params
    })
  },
  getPointList: params => {
    return request({
      url: '/point/list',
      method: 'get',
      params
    })
  }
}
export default baseApi
